import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function MolecularHeatersUseCase() {
  return (
    <>
    <section
      id="molecular-heaters"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">
        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Molecular Heaters
          </h1>
          <p className="text-slate-300 space-y-2">
            Molecular heaters absorb light and convert it to heat via non-radiative decay. In agriculture and materials science, such molecules offer a green solution to challenges like crop resilience and thermal control. Recent work by Stavros and coworkers<sup>[1]</sup> demonstrated that sinapic diacid (SDA) can act as an effective photothermal agent, raising leaf temperatures under sunlight and improving crop yield potential.
            <br /><br />
            The key lies in tailoring vibrational modes and energy gaps to maximise photothermal conversion efficiency while maintaining environmental compatibility. Computational screening is vital to accelerate the design of such molecules.
          </p>
        </div>

        {/* How Apoello helps */}
<div className="space-y-4">
  <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
  <ul className="list-disc list-inside text-slate-300 space-y-2">
    <li>
      Screen molecules for strong absorption in the UV–visible–NIR region.
    </li>
    <li>
      Estimate excited-state lifetimes and identify candidates with rapid non-radiative decay.
    </li>
    <li>
      Explore vibrational contributions to internal conversion and photothermal efficiency.
    </li>
    <li>
      Order promising molecular heaters for validation in lab-based photothermal tests.
    </li>
  </ul>
</div>

        {/* Why it matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why it matters</h2>
          <p className="text-slate-300 max-w-3xl">
            Photothermal molecules offer an eco-friendly route to improving crop productivity, protecting plants from cold stress, and enabling smarter, passive thermal systems. Computational discovery dramatically shortens the time needed to reach field trials.
          </p>
        </div>

        {/* References */}
        <div className="space-y-4 pt-10">
          <h2 className="text-2xl font-semibold text-orange-300">
            References
          </h2>

          <ol className="list-decimal list-inside text-slate-400 space-y-1 text-sm">
            <li>
              Woolley, J. M. <i>et al.</i> <i>Molecular heaters: a green route to boosting crop yields?</i>, <i>Phys. Chem. Chem. Phys.</i> <b>2025</b>, 27, 7375–7382. {" "}
              <a
                href="https://doi.org/10.1039/D4CP04803B"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#F89B3F] underline"
              >
                Link ↗
              </a>
            </li>
          </ol>
        </div>

        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>
      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}